<template>
  <div class="chart-skeleton">
    <template v-if="type === 'lines'">
      <div
        v-for="(line, index) in skeletonLines"
        :key="index"
        class="skeleton-line"
        :style="{ width: line.width }"
      ></div>
    </template>
    <template v-else-if="type === 'bar'">
      <div class="skeleton-bar-container">
        <div
          v-for="(height, index) in barHeights"
          :key="'bar-' + index"
          class="skeleton-bar"
          :style="{ height: height }"
        ></div>
      </div>
    </template>
    <template v-else-if="type === 'pie'">
      <div class="skeleton-pie"></div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'lines',
    validator: (value) => ['lines', 'pie', 'bar'].includes(value)
  },
  lines: {
    type: Number,
    default: 5,
    validator: (value) => value > 0
  }
})

const skeletonLines = computed(() => {
  return Array.from({ length: props.lines }, (_, i) => ({
    width: `${Math.floor(75 + Math.random() * 25)}%`
  }))
})

const barHeights = computed(() => {
  return ['40%', '60%', '80%', '50%', '70%', '65%', '90%']
})
</script>

<style scoped>
.chart-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 0;
  min-height: 360px;
  width: 100%;
}

.skeleton-line {
  height: 8px;
  width: 100%;
  max-width: 600px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
}

.skeleton-bar-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  width: 100%;
  max-width: 400px;
  height: 200px;
}

.skeleton-bar {
  flex: 1;
  min-width: 20px;
  max-width: 40px;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  border-radius: 4px 4px 0 0;
  animation: shimmer 1.5s infinite;
}

/* Pie */
.skeleton-pie {
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  margin-top: 20px; 
}

@keyframes shimmer {
  0% { 
    background-position: -200% 0; 
  }
  100% { 
    background-position: 200% 0; 
  }
}
</style>